export default "__VITE_ASSET__DPxSfMNw__"